import gql from 'graphql-tag';

export const GET_AGGREGATE_MERCHANT_MEMBERSHIPS_METRICS = gql`
  fragment aggregateMemberships on AggregateMemberships {
    periodStart
    annualMemberships
    monthlyMemberships
    totalMembershipRevenue
    cashbackAmount
    campaignFeeAmount
  }

  query getAggregateMerchantMembershipMetrics($params: ReportInput!) {
    aggregateMerchantMembershipMetrics(params: $params) {
      result {
        totals {
          ...aggregateMemberships
        }

        online {
          ...aggregateMemberships
        }

        inStore {
          ...aggregateMemberships
        }
      }
    }
  }
`;

export default GET_AGGREGATE_MERCHANT_MEMBERSHIPS_METRICS;
